<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_ix"><span class="txbf">CONTENTS</span></a></h2><a id="page_ix">
<p class="image1"><img alt="images" height="2" src="images/line.jpg" width="200"/></p>
</a><p class="toc-front"><a id="page_ix"></a><a href="#/xhtml/intro#intro">INTRODUCTION</a></p>
<p class="toc-chap"><a href="#/xhtml/ch01#ch01">1. THEY MADE A DIFFERENCE</a></p>
<p class="toc-chap1"><a href="#/xhtml/ch01#ch01">Leaders Who Changed the World</a></p>
<p class="toc-chap"><a href="#/xhtml/ch02#ch02">2. WINSTON CHURCHILL</a></p>
<p class="toc-chap1"><a href="#/xhtml/ch02#ch02">The Largest Human Being of Our Time</a></p>
<p class="toc-chap"><a href="#/xhtml/ch03#ch03">3. CHARLES de GAULLE</a></p>
<p class="toc-chap1"><a href="#/xhtml/ch03#ch03">The Leadership Mystique</a></p>
<p class="toc-chap"><span href="#/xhtml/ch04#ch04" title="Link target outside of Sample">4. DOUGLAS MacARTHUR AND SHIGERU YOSHIDA</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch04#ch04" title="Link target outside of Sample">East Meets West</span></p>
<p class="toc-chap"><span href="#/xhtml/ch05#ch05" title="Link target outside of Sample">5. KONRAD ADENAUER</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch05#ch05" title="Link target outside of Sample">The West’s Iron Curtain</span></p>
<p class="toc-chap"><span href="#/xhtml/ch06#ch06" title="Link target outside of Sample">6. NIKITA KHRUSHCHEV</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch06#ch06" title="Link target outside of Sample">The Brutal Will To Power</span></p>
<p class="toc-chap"><span href="#/xhtml/ch07#ch07" title="Link target outside of Sample">7. ZHOU ENLAI</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch07#ch07" title="Link target outside of Sample">The Mandarin Revolutionary</span></p>
<p class="toc-chap"><span href="#/xhtml/ch08#ch08" title="Link target outside of Sample">8. A NEW WORLD</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch08#ch08" title="Link target outside of Sample">New Leaders in a Time of Change</span></p>
<p class="toc-chap"><span href="#/xhtml/ch09#ch09" title="Link target outside of Sample">9. IN THE ARENA</span></p>
<p class="toc-chap1"><span href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Reflections on Leadership</span></p>
<p class="toc-back"><span href="#/xhtml/author#author" title="Link target outside of Sample">AUTHOR’S NOTE</span></p>
<p class="toc-back"><span href="#/xhtml/insert" title="Link target outside of Sample">PHOTOGRAPHS</span></p>
<p class="toc-back"><span href="#/xhtml/index#index" title="Link target outside of Sample">INDEX</span><a id="page_x"></a></p><a id="page_x">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?5451607c